import { JSX } from 'react'

import { IconProps } from '../../icon'

const Blog: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M35.4872 10H12.5128C10.0185 10 8 12.0185 8 14.5128V34.2051C8 36.6995 10.0185 38.7179 12.5128 38.7179H35.4872C37.9815 38.7179 40 36.6995 40 34.2051V14.5128C40 12.0185 37.9815 10 35.4872 10ZM12.5128 12.4615H35.4872C36.6195 12.4615 37.5385 13.3805 37.5385 14.5128V16.5641H10.4615V14.5128C10.4615 13.3805 11.3805 12.4615 12.5128 12.4615ZM35.4872 36.2564H12.5128C11.3805 36.2564 10.4615 35.3374 10.4615 34.2051V19.0256H37.5385V34.2051C37.5385 35.3374 36.6195 36.2564 35.4872 36.2564Z'
      fill='black'
    />
    <path
      d='M32.2051 23.1282H15.7949C15.122 23.1282 14.5641 23.6862 14.5641 24.359C14.5641 25.0318 15.122 25.5897 15.7949 25.5897H32.2051C32.8779 25.5897 33.4359 25.0318 33.4359 24.359C33.4359 23.6862 32.8779 23.1282 32.2051 23.1282Z'
      fill='black'
    />
    <path
      d='M33.879 15.7436C34.5518 15.7436 35.1097 15.1856 35.1097 14.5128C35.1097 13.84 34.5518 13.2821 33.879 13.2821H33.8626C33.1897 13.2821 32.6482 13.84 32.6482 14.5128C32.6482 15.1856 33.2061 15.7436 33.879 15.7436Z'
      fill='black'
    />
    <path
      d='M24 29.6923H15.7949C15.122 29.6923 14.5641 30.2503 14.5641 30.9231C14.5641 31.5959 15.122 32.1538 15.7949 32.1538H24C24.6728 32.1538 25.2308 31.5959 25.2308 30.9231C25.2308 30.2503 24.6728 29.6923 24 29.6923Z'
      fill='black'
    />
  </svg>
)

export default Blog
